/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

/**
 * Create Vue application and attach components
 */

import '@babel/polyfill';

import Vue from 'vue';
import './bootstrap.js';
import router from './routes';
import moment from 'moment';

window.Vue = Vue;
window.moment = moment;

window.Dropzone = require('dropzone');
window.Cropper = require('cropperjs');
require('jquery-ui');
require('jquery-ui-sortable-npm');

require('./selectric');

require('./touch-devices');

require('./main');

require('./illustrator_dashboard');

require('./publisher-interviews');

require('./logo');

require('./masonry');

require('./retina_images_handling');

require('./wysiwyg');

require('./side');

require('./image-set');

require('./portfolio-directory');

require('./services/table-sortable');

require('./social-links');

var axios = require('axios');
var VueAxios = require('vue-axios');
Vue.use(VueAxios, axios);

const component = module => module.default || module;

Vue.component('example', component(require('./components/Example.vue')));
Vue.component('image-inputs-list', component(require('./components/ImageInputsList.vue')));
Vue.component('post-image-inputs-list', component(require('./components/Post/ImageInputsList.vue')));
Vue.component('image-input', component(require('./components/ImageInput.vue')));
Vue.component('post-image-input', component(require('./components/Post/ImageInput.vue')));
Vue.component('question', component(require('./components/Question.vue')));
Vue.component('expanded-question', component(require('./components/ExpandQuestion.vue')));
Vue.component('image-collection-item', component(require('./components/ImageCollectionItem.vue')));
Vue.component('image-collection-items', component(require('./components/ImageCollectionItemsList.vue')));
Vue.component('interview-questions', component(require('./components/InterviewQuestions.vue')));
Vue.component('commissioner-interview', component(require('./components/CommissionerInterview.vue')));
Vue.component('commissioner-interview-part', component(require('./components/CommissionerInterviewPart.vue')));
Vue.component('illustrator-clients', component(require('./components/IllustratorClients.vue')));
Vue.component('illustrator-client', component(require('./components/IllustratorClient.vue')));
Vue.component('studio-shots', component(require('./components/StudioShots.vue')));
Vue.component('studio-shot', component(require('./components/StudioShot.vue')));
Vue.component('agency-locations', component(require('./components/AgencyLocations.vue')));
Vue.component('agency-location', component(require('./components/AgencyLocation.vue')));
Vue.component('art-buyers', component(require('./components/ArtBuyers.vue')));
Vue.component('art-buyer', component(require('./components/ArtBuyer.vue')));
Vue.component('upgrade-calendar', component(require('./components/UpgradeCalendar.vue')));
Vue.component('pagination', component(require('./components/Pagination.vue')));
Vue.component('search-illustrations', component(require('./components/Search/SearchIllustrations.vue')));
Vue.component('collection-edit', component(require('./components/CollectionEdit/Index.vue')));
Vue.component('post-images-block', component(require('./components/Post/ImagesBlock.vue')));
Vue.component('post-images-blocks', component(require('./components/Post/ImagesBlocks.vue')));
Vue.component('ck-editor', component(require('./components/ui/CKEditor')));
Vue.component('validation-message', component(require('./components/ui/ValidationMessage')));
Vue.component('ValidationMessage', component(require('./components/ui/ValidationMessage')));
Vue.component('spinner', component(require('./components/ui/Spinner')));
Vue.component('service-item', component(require('./components/services/ServiceItem.vue')));
Vue.component('LoadingBar', component(require('./components/ui/LoadingBar')));
Vue.component('TheSignUpNewsletter', component(require('./components/TheSignUpNewsletter/Index')));
Vue.component('InterviewDelete', component(require('./components/InterviewDelete')));
Vue.component('TruncateHtml', component(require('./components/common/TruncateHtml')));

//Page components
Vue.component('motion-index', component(require('./components/pages/motions/Index.vue')));
Vue.component('motion-show', component(require('./components/pages/motions/Show.vue')));
Vue.component('domain-index', component(require('./components/pages/admin/domains/Index.vue')));
Vue.component('discount-codes-list', component(require('./components/pages/admin/discount-codes/List')));
Vue.component('discount-codes-form', component(require('./components/pages/admin/discount-codes/Form')));
Vue.component('illustrator-profile', component(require('./components/pages/illustrator/Profile')));
Vue.component('illustrator-news-form', component(require('./components/pages/illustrator/news/Form')));
Vue.component('admin-interview-index', component(require('./components/pages/admin/interviews/Index')));
Vue.component('agency-interview-index', component(require('./components/pages/agency/interviews/Index')));

Vue.component('interview', component(require('./components/Interview')));

new Vue({
  el: '#app',

  data: {
    showMainLoadingBar: false
  },

  router,
});
